import { ReactNode } from 'react';

type PageCardProps = {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  className?: string;
  role?: string;
  'aria-label'?: string;
};

export function PageCard({
  children,
  title,
  subtitle,
  className = '',
  role,
  'aria-label': ariaLabel,
}: PageCardProps) {
  return (
    <section className={`erp-card ${className}`.trim()} role={role} aria-label={ariaLabel}>
      <div className="erp-card-body">
        {title ? (
          <div>
            <h2 className="erp-card-title">{title}</h2>
            {subtitle ? <p className="erp-card-subtitle">{subtitle}</p> : null}
          </div>
        ) : null}
        {children}
      </div>
    </section>
  );
}
